export const ec_zhCN = {
  'ec.dashboard.n01.lbl01': `会员整体变化`,
  'ec.dashboard.n01.lbl02': `会员数`,
  'ec.dashboard.n01.lbl03': `活跃会员数`,
  'ec.dashboard.n01.lbl04': `休眠会员数`,
  'ec.dashboard.n01.tip05': `会员整体变化反映了会员按日/周/月统计的总会员数、活跃及休眠会员数的总量变化`,
  'ec.dashboard.n01.tip06': `活跃会员数`,
  'ec.dashboard.n01.tip07': `休眠会员数`,
  'ec.dashboard.n02.lbl01': `会员变化趋势`,
  'ec.dashboard.n02.lbl02': `总会员数`,
  'ec.dashboard.n02.lbl03': `新会员数`,
  'ec.dashboard.n02.lbl04': `活跃会员数`,
  'ec.dashboard.n02.lbl06': `VIP新会员数`,
  'ec.dashboard.n02.lbl07': `VIP活跃会员数`,
  'ec.dashboard.n02.tip05': `反映指定周期内新会员与活跃会员的数量变化趋势`,
  'ec.dashboard.n02.tip06': `新增会员数`,
  'ec.dashboard.n02.tip07': `活跃会员数`,
  'ec.dashboard.n03.lbl01': `年龄分布`,
  'ec.dashboard.n03.lbl01.tip01': `会员按年龄段占⽐统计`,
  'ec.dashboard.n04.lbl01': `来源分布`,
  'ec.dashboard.n04.lbl01.tip01': `会员按注册渠道占⽐统计`,
  'ec.dashboard.n05.lbl01': `等级分布`,
  'ec.dashboard.n05.lbl01.tip01': `会员按会员等级占⽐统计`,
  'ec.dashboard.n06.lbl01': `24小时活跃会员数`,
  'ec.dashboard.n06.tip01': `昨日24小时内按时段的各渠道活跃会员数的变化趋势`,
  'ec.dashboard.n07.lbl01': `销售额趋势`,
  'ec.dashboard.n07.lbl02': '订单笔数',
  'ec.dashboard.n07.lbl03': `订单金额`,
  'ec.dashboard.n07.lbl04': `票数`,
  'ec.dashboard.n07.lbl05': `VIP`,
  'ec.dashboard.n07.lbl06': `会员`,
  'ec.dashboard.n07.tip01': `7天/30天内会员每日累积消费金额的变化`,
  'ec.dashboard.n08.lbl01': `积分变化趋势`,
  'ec.dashboard.n08.tip02': `7天/30天内会员每⽇累积积分获取/消耗的变化`,
  'ec.dashboard.n09.tip01': '发放',
  'ec.dashboard.n09.tip02': '扣减',
  'ec.dashboard.n09.tip03': '余额',
  'ec.dashboard.n02.lbl05': `新/活：`,
  'ec.dashboard.new01.lbl01': `性别分布`,
  'ec.dashboard.new01.lbl01.desc01': `会员按性别占比统计`,
  'ec.dashboard.new01.lbl02': `地域分布`,
  'ec.dashboard.new01.lbl02.desc01': `会员按地域占比统计`,
  'ec.dashboard.new01.lbl03': `消费能力分布`,
  'ec.dashboard.new01.lbl03.desc01': `会员按消费能力占比统计`,
  'ec.dashboard.new01.lbl04': `小程序整体访问`,
  'ec.dashboard.new01.lbl04.desc01': `7天/30天内会员每日访问的变化`,
  'ec.dashboard.new01.lbl05': `积分持有分布`,
  'ec.dashboard.new01.lbl05.desc01': `会员按积分持有占比统计`,
  // tooltip
  'ec.dashboard.n01.lbl01.desc01':
    '会员整体变化反应了会员按日/周/月统计的总会员数、活跃及休眠会员数的总量变化',
  'ec.dashboard.n01.lbl01.desc02':
    '活跃会员数：统计周期内产生过消费或参与过互动事件的会员数量',
  'ec.dashboard.n01.lbl01.desc03':
    '休眠会员数：指定周期无消费或参与任意互动事件的会员数量',
  'ec.dashboard.n02.lbl01.desc01':
    '反应指定周期内新会员与活跃会员的数量变化趋势',
  'ec.dashboard.n02.lbl01.desc02': '新增会员数：7天/30天内会员新增增速变化',
  'ec.dashboard.n02.lbl01.desc03': '活跃会员数：7天/30天内每日活跃会员数量变化',
  'ec.dashboard.n06.lbl01.desc01':
    '昨日24小时内按时段的各渠道活跃会员数的变化趋势',
  'ec.dashboard.n07.lbl01.desc01': '7天/30天内会员每日累积消费金额的变化',
  'ec.dashboard.n08.lbl01.desc01': '7天/30天内会员每日累积积分获取/消耗的变化',
  'ec.dashboard.n03.lbl01.desc01': '会员按年龄段占比统计',
  'ec.dashboard.n03.lbl01.desc02': '完善信息:{profileCompletedCount}',
  'ec.dashboard.n03.lbl01.desc03': '填写年龄:{ageFilledCount}',
  'ec.dashboard.n05.lbl01.desc01': '会员按会员等级占比统计',
  'ec.dashboard.n04.lbl01.desc01': '会员按注册渠道占比统计',
  'cm.mm.ml.c02.desc01': '当前会员的积分在全部会员中所处的排名位置',
  'cm.mm.ml.c04.desc01': '当前会员在消费积分时所使用的各个渠道分布',
  'cm.mm.ml.c05.desc01': '当前会员进行消费时的相关渠道比例',
  'cm.mm.ml.c06.desc01': '当前会员近十二个月的消费变化趋势',
  'cm.mm.ml.c03.desc01': '当前会员近十二个月的积分增加及减少的变化趋势',
  'cm.mm.ml.c07.desc01': '展示当前会员入会后的会员等级变化事件',
  'ec.report.c01.desc01': '统计周期内产生过消费或参与过互动事件的会员数量',
  'ec.report.c02.desc02': '统计周期内注册后第一次发生消费的会员数量',
  'ec.report.c03.desc03': '统计周期内消费次数大于1的会员数量',
  'ec.report.c04.desc04': '统计周期内所有会员获取的积分数量',
  'ec.report.c05.desc05': '统计周期内所有会员消耗的积分数量',
  'ec.report.c06.desc06': '指定周期内所有会员获取积分的方式占比',
  'ec.report.c07.desc07': '指定周期内所有会员获取扣减的方式占比',
  'ec.report.c08.desc08': '按天统计所有会员的核销比,核销比=发放积分：核销积分',
  'ec.report.c09.desc09':
    '每日发放积分：7天/30天内会员每日累积获取积分的变化趋势',
  'ec.report.c09.desc10':
    '每日核销积分：7天/30天内会员每日累积消耗积分的变化趋势',
  'ec.report.c09.desc11': '每日可用积分：每日会员的获取积分-消耗积分',
  'ec.report.c10.desc10': '指定周期内所有会员的人均消费金额',
  'ec.report.c10.desc11': '会员客单价=消费总金额/消费总人数',
  'ec.report.c11.desc11':
    '饼图为指定周期内订单的来源店铺的金额占比，可选择店铺在右侧组合图中查看该店铺下的订单成交会员人数/订单   成交会员金额/订单成交笔数',
  'ec.report.c11.desc12': '成交会员人数：指定店铺下每日的成交订单的总人数',
  'ec.report.c11.desc13': '成交会员金额：指定店铺下每日的成交订单的总金额',
  'ec.report.c11.desc14': '成交订单笔数：指定店铺下每日的成交订单数量',
  'ec.report.c12.desc12': '统计周期内所有会员数量以及发生过购买的会员数量',
  'ec.report.c13.desc13': '指定周期内所有SKU成交的件数',
  'ec.report.c14.desc14': '统计周期内所有会员数量以及发生过购买的会员数量',
};

export const ec_enUS = {
  'ec.dashboard.n01.lbl01': `MEMBERSHIP INTEGRATED TRENDS`,
  'ec.dashboard.n01.lbl02': `TOTAL MEMBERS `,
  'ec.dashboard.n01.lbl03': `ACTIVE MEMBERS`,
  'ec.dashboard.n01.lbl04': `INACTIVE MEMBERS`,
  'ec.dashboard.n01.tip05': `It presents quantities changing of total,active and inactive members,according to counting by daily or weekly or monthly.`,
  'ec.dashboard.n01.tip06': `Active members: Amount of who consumes or join in activities in counting cycle`,
  'ec.dashboard.n01.tip07': `Inactive members: Amount of who don’t consume or join in activities in counting cycle`,
  'ec.dashboard.n02.lbl01': `NUMBER OF MEMBERS TRENDS`,
  'ec.dashboard.n02.lbl02': `TOTAL MEMBERS `,
  'ec.dashboard.n02.lbl03': `NEW MEMBERS`,
  'ec.dashboard.n02.lbl04': `ACTIVE MEMBERS`,
  'ec.dashboard.n02.tip05': `Trends changing in counting cycle`,
  'ec.dashboard.n02.tip06': `New Members: Amount of new members changing in 7 and 30 days`,
  'ec.dashboard.n02.tip07': `Active Members: Amount of active members changing in 7 and 30 days`,
  'ec.dashboard.n03.lbl01': `AGE DISTRIBUTION`,
  'ec.dashboard.n03.lbl01.tip01': `Counting members via age`,
  'ec.dashboard.n04.lbl01': `SOURCE DISTRIBUTION`,
  'ec.dashboard.n04.lbl01.tip01': `Counting members via source of registrating`,
  'ec.dashboard.n05.lbl01': `LEVEL DISTRIBUTION`,
  'ec.dashboard.n05.lbl01.tip01': `Counting members via rank of member`,
  'ec.dashboard.n06.lbl01': `ACTIVE MEMBERS IN 24H`,
  'ec.dashboard.n06.tip01': `Trends changing of active members in past 24h`,
  'ec.dashboard.n07.lbl01': `REVENUE TRENDS`,
  'ec.dashboard.n07.lbl02': `Amount of Orders`, //订单笔数
  'ec.dashboard.n07.lbl03': `SALES OF ORDERS`,
  'ec.dashboard.n07.tip01': `Daily cumulative consumption changing in 7 or 30d`,
  'ec.dashboard.n08.lbl01': `POINTS TRENDS`,
  'ec.dashboard.n08.tip02': `Daily points changing by day in 7 or 30d`,
  'ec.dashboard.n09.tip01': `ISSUE`,
  'ec.dashboard.n09.tip02': `REDUCE`,
  'ec.dashboard.n09.tip03': `REMAINING`,
  'ec.dashboard.n02.lbl05': `NEW/ACTIVE`,
  'ec.report.c01.desc01':
    'Quantity of members who attended interactivities and purchased during statistical period', //'统计周期内产生过消费或参与过互动事件的会员数量',
  'ec.report.c02.desc02':
    'Quantity of members who frist purchased after registered during statistical period', //'统计周期内注册后第一次发生消费的会员数量',
  'ec.report.c03.desc03':
    'Quantity of members who purchased times more than twice during statistical period', //'统计周期内消费次数>=2的会员数量',
  'ec.report.c04.desc04':
    'Quantity of pionts that all members earned during statistical per', //'统计周期内所有会员获取的积分数量',
  'ec.report.c05.desc05':
    'Quantity of pionts that all members redeemed during statistical period', //'统计周期内所有会员消耗的积分数量',
  'ec.report.c06.desc06':
    'Percentage of various methods to earn points during statistical period', //'指定周期内所有会员获取积分的方式占比',
  'ec.report.c07.desc07':
    'Percentage of various methods to redeem points during statistical period', //'指定周期内所有会员获取扣减的方式占比',
  'ec.report.c08.desc08': 'the ratio of earning to redeeming daily points', //'按天统计所有会员的核销比,核销比=发放积分：核销积分',
  'ec.report.c09.desc09':
    'Daily earning points : changing trends of earning points in 7 day and 30 days Daily redeeming points: changing trends of redeeming points in 7 days and 30 days Daily  available points: earn points - redeem points daily', // '每日发放积分：7天/30天内会员每日累积获取积分的变化趋势,每日核销积分：7天/30天内会员每日累积消耗积分的变化趋势,每日可用积分：每日会员的获取积分-消耗积分',
  'ec.report.c10.desc10':
    'Average revenue of total members Per Customer Transaction = Total Revenue / quantity of member', //'指定周期内所有会员的人均消费金额会员客单价=消费总金额/消费总人数',
  'ec.report.c11.desc11': '',
  'ec.report.c12.desc12':
    'Quantity of total members and quantity of members who purchased during statistical period', //'统计周期内所有会员数量以及发生过购买的会员数量',
  'ec.report.c13.desc13':
    'Reveal the tendency about change in value of new members and active members during specified period.New member: Registered member during specified period.Inactive member: The last consumption or interaction incident occurred over the expiration date more than 90 days.', //'反应指定周期内新会员与活跃会员的数量变化趋势新增会员：指定周期内注册入会的会员休眠会员：会员最后一次消费或者参与过互动事件的日期至数据截止日期,超过90天的会员数',
  'ec.report.c14.desc14':
    'Quantity of total members and quantity of members who purchased during statistical period', //'统计周期内所有会员数量以及发生过购买的会员数量',
  // 'ec.dashboard.n01.lbl01.desc01':
  //   'According to daily weekly monthly counting, it presents total members, new members and  active members trends changing',
  'ec.dashboard.n01.lbl01.desc01':
    'It presents quantities changing of total,active and inactive members,according to counting by daily or weekly or monthly.',
  'ec.dashboard.n01.lbl01.desc02':
    'Amount of who consumes or join in activities in counting cycle',
  'ec.dashboard.n02.lbl01.desc01': 'Trends changing in counting cycle',
  'ec.dashboard.n02.lbl01.desc02':
    'Amount of new members changing in 7 and 30 days',
  'ec.dashboard.n02.lbl01.desc03':
    'Amount of active members changing in 7 and 30 days',
  'ec.dashboard.n02.lbl01.desc04':
    'active members:number of members changing in 7 and 30 days',
  // 'ec.dashboard.n06.lbl01.desc01':
  //   'counting percentage of active members among channals in 24 hours',
  'ec.dashboard.n06.lbl01.desc01':
    'Trends changing of active members in past 24h',
  'ec.dashboard.n07.lbl01.desc01':
    'Daily cumulative consumption changing in 7 or 30d',
  'ec.dashboard.n08.lbl01.desc01': 'Daily points changing by day in 7 or 30d',
  'ec.dashboard.n03.lbl01.desc01': 'counting members via age',
  'ec.dashboard.n05.lbl01.desc01': 'Counting members via rank of member',
  'ec.dashboard.n04.lbl01.desc01':
    'Counting members via source of registrating',
  'cm.mm.ml.c02.desc01': 'position in whole members points',
  'cm.mm.ml.c04.desc01': 'consume points distribution of channals',
  'cm.mm.ml.c05.desc01': 'percentage of consumption channals',
  'cm.mm.ml.c06.desc01': 'consumpitions trends changing in 12 monthes',
  'cm.mm.ml.c03.desc01': 'points trends changing in 12 monthes',
  'cm.mm.ml.c07.desc01': 'Present member level changing events',
  'ec.dashboard.n01.lbl01.desc03':
    'Amount of who don’t consume or join in activities in counting cycle',
};
